var _path, _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivetrue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.2896 4.85275L161.84 44.4305C163.815 45.5707 165.032 47.6777 165.032 49.958V129.114C165.032 131.394 163.815 133.501 161.84 134.641L93.2896 174.219C91.3148 175.359 88.8818 175.359 86.907 174.219L18.3563 134.641C16.3815 133.501 15.165 131.394 15.165 129.114V49.958C15.165 47.6777 16.3815 45.5707 18.3563 44.4305L86.907 4.85275C88.8818 3.71262 91.3148 3.71262 93.2896 4.85275Z",
    fill: "#D9D9D9",
    stroke: "url(#paint0_linear_740_521)",
    strokeWidth: 5.21393
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_740_521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.3054 6.69817C89.0899 5.66788 91.2885 5.66788 93.073 6.69817L160.564 45.664C162.348 46.6943 163.448 48.5983 163.448 50.6589V128.591C163.448 130.651 162.348 132.555 160.564 133.585L93.073 172.551C91.2885 173.582 89.0899 173.582 87.3054 172.551L19.8146 133.585C18.0301 132.555 16.9308 130.651 16.9308 128.591V50.6589C16.9308 48.5983 18.0301 46.6943 19.8146 45.664L87.3054 6.69817Z",
    fill: "#2FB1E9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_740_521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.3151 23.9599C88.0996 22.9296 90.2982 22.9296 92.0827 23.9599L144.704 54.3407C146.488 55.371 147.588 57.275 147.588 59.3356V120.097C147.588 122.158 146.488 124.062 144.704 125.092L92.0827 155.473C90.2982 156.503 88.0996 156.503 86.3151 155.473L33.6939 125.092C31.9094 124.062 30.8101 122.158 30.8101 120.097V59.3356C30.8101 57.275 31.9094 55.371 33.6939 54.3407L86.3151 23.9599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.322 51.5381L93.7008 21.1572C90.915 19.5488 87.4827 19.5488 84.6969 21.1572L32.0758 51.5381C29.29 53.1464 27.5739 56.1188 27.5739 59.3356V120.097C27.5739 123.314 29.29 126.286 32.0758 127.895L84.6969 158.276C87.4827 159.884 90.915 159.884 93.7008 158.276L146.322 127.895C149.108 126.286 150.824 123.314 150.824 120.097V59.3356C150.824 56.1189 149.108 53.1464 146.322 51.5381Z",
    stroke: "url(#paint1_diamond_740_521)",
    strokeWidth: 6.47247
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_740_521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.3151 23.9599C88.0996 22.9296 90.2982 22.9296 92.0827 23.9599L144.704 54.3407C146.488 55.371 147.588 57.275 147.588 59.3356V120.097C147.588 122.158 146.488 124.062 144.704 125.092L92.0827 155.473C90.2982 156.503 88.0996 156.503 86.3151 155.473L33.6939 125.092C31.9094 124.062 30.8101 122.158 30.8101 120.097V59.3356C30.8101 57.275 31.9094 55.371 33.6939 54.3407L86.3151 23.9599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4645 26.7625L143.086 57.1434C143.869 57.5956 144.351 58.4312 144.351 59.3356V120.097C144.351 121.002 143.869 121.837 143.086 122.29L90.4645 152.67C89.6813 153.123 88.7164 153.123 87.9332 152.67L35.312 122.289C34.5288 121.837 34.0463 121.002 34.0463 120.097V59.3356C34.0463 58.4312 34.5288 57.5956 35.312 57.1434L87.9332 26.7625C88.7164 26.3104 89.6813 26.3104 90.4645 26.7625Z",
    stroke: "url(#paint2_diamond_740_521)",
    strokeWidth: 6.47247
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_740_521",
    x: 16.9297,
    y: 5.92578,
    width: 147.289,
    height: 167.398,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.769014
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.18662
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.52 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_740_521"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_740_521",
    x: 21.2615,
    y: 13.6404,
    width: 135.871,
    height: 152.153,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.53721
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_740_521"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_740_521",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_740_521",
    x: 27.7342,
    y: 20.1131,
    width: 122.926,
    height: 139.207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.53721
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_740_521"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_740_521",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_740_521",
    x1: 127.675,
    y1: 157.317,
    x2: 46.6788,
    y2: 23.3728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.257406
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_diamond_740_521",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(89.1989 89.7164) rotate(90) scale(67.4215 123.256)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#2FB1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A6483"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_diamond_740_521",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(89.1989 89.7164) rotate(90) scale(67.4215 123.256)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivetrue);
export default __webpack_public_path__ + "static/media/Active=true.592f111598873ca8c1d1eb3556aee19f.svg";
export { ForwardRef as ReactComponent };